export const iconFontAwesomePunctuationSymbolsPlus = (
	<i className="fa-solid fa-plus"></i>
);
